{
    "accept": "Accept",
    "action_open_in_external_app": "Open in ${1}",
    "all": "All",
    "apply": "Apply",
    "back": "Back",
    "cancel": "Cancel",
    "choose": "Choose",
    "clear": "Clear",
    "clear_all": "Clear all",
    "clear_filters": "Clear Filters",
    "client_offline_error_description": "You’re offline. Please check your internet connection and try again.",
    "client_offline_error_title": "No Internet Connection",
    "client_timeout_error_description": "We couldn’t complete your request due to a connection timeout. Please check your connection and try again. If the problem persists, our support team is here to help.",
    "client_timeout_error_title": "Connection Timed Out.",
    "content_missing": "The content is missing.",
    "delete": "Delete",
    "description": "Description",
    "dismiss": "Dismiss",
    "done": "Done",
    "donor_feedback_anonymized": "We already anonymised your data due to data protection reasons.",
    "donor_feedback_incorrect_link": "The link you are using is not correct - please make sure you are using the complete link sent to you.",
    "donor_feedback_not_found": "Unfortunately, this link is invalid, this can have one of the following reasons:",
    "error_occurred": "An error occurred",
    "expired": "Expired",
    "failed": "Failed",
    "field_address_search_accuracy_hint": "Improve search results by granting the app access to your location via the settings of the operating system.",
    "field_error_address_unsupported_country": "Address not in accepted country",
    "field_error_any": "Please provide at least one of these fields: ${1}",
    "field_error_date_invalid": "Please provide a valid date",
    "field_error_date_max": "The date must be ${1} or before",
    "field_error_date_min": "The date must be ${1} or after",
    "field_error_date_range_max": "The date must be before ${1}",
    "field_error_date_range_min": "The date must be after ${1}",
    "field_error_email": "Please provide a valid email",
    "field_error_length_max": "This field is restricted to ${1} characters",
    "field_error_length_min": "Please provide a minimum of ${1} characters",
    "field_error_max": "The maximum value is ${1}",
    "field_error_min": "The minimum value is ${1}",
    "field_error_pattern": "The input is invalid",
    "field_error_phone_invalid": "Please provide a valid phone number",
    "field_error_phone_starts_with_zero": "A country code already exists. Please remove the leading \"0\" from the phone number.",
    "field_error_required": "Please fill out this field",
    "field_is_required": "This field is required",
    "field_placeholder_address_search": "Enter a location",
    "field_select_not_found": "'${1}' could not be found",
    "font_big": "big font",
    "font_medium": "medium font",
    "font_small": "small font",
    "last_attempt": "Last attempt",
    "last_upload": "Last upload",
    "link_sent": "Link sent, please check",
    "network_error": "Network error",
    "network_error_cookies_disabled_description": "It looks like you have disabled all Cookies? Maybe try another browser",
    "network_error_cookies_disabled_title": "Cookies Disabled",
    "next": "Next",
    "no_results": "No results",
    "offline": "offline",
    "ok": "OK",
    "online": "online",
    "open": "Open",
    "page_not_found_description": "The page you tried to request doesn't exist. You might have mistyped the URL.",
    "page_not_found_link": "Return to homepage.",
    "page_not_found_title": "Page Not Found",
    "pagination_result": "${1} - ${2} of ${3} Results",
    "passed": "Passed",
    "request_support": "Request support",
    "request_support_error_title": "Request failed",
    "request_support_success_description": "We received your support request.",
    "request_support_success_title": "Request received",
    "reset_filters_description": "Try adjusting your search or filters.",
    "result": "Result",
    "retry": "Retry",
    "save": "Save",
    "select_group_selected": "Selected",
    "send_a_support_request": "Support Request",
    "server_unavailable_error_description": "The service is temporarily unavailable. Please check again later.",
    "server_unavailable_error_title": "Service unavailable",
    "server_unexpected_error_description": "Something went wrong on our end. Please try again in a moment. If the problem continues, please reach out to our support.",
    "server_unexpected_error_title": "An unexpected error occured.",
    "state_done": "Done",
    "state_not_uploaded": "Not uploaded",
    "state_pending": "Pending",
    "state_refused": "Refused",
    "state_uploading": "Uploading",
    "submit": "Submit",
    "support_request_type": "Type",
    "support_request_type_crash": "Crash",
    "support_request_type_critical": "Critical",
    "support_request_type_minor": "Minor",
    "support_request_type_other": "Other",
    "toggle_detail_view": "Detail view",
    "toggle_list_view": "List view",
    "type": "Type",
    "unknown_error": "Something Went Wrong",
    "unknown_error_description": "An unexpected error occurred. Please try again. If the issue persists, contact support.",
    "uploading": "Uploading...",
    "validating": "Hold on, we’re making sure everything is correct..."
}